/**
 * @deprecated Previous in-app Stripe room-payment flow. Kept as an example of how we
 * started checkout (`fetchPaymentGetCheckoutSession`) and tracked `paymentRoomId` for
 * return redirects. No UI currently dispatches this after the pod payment wizard was
 * removed; do not delete — we may reuse this pattern.
 */
import { fetchPaymentGetCheckoutSession, type UrlResult } from "@crowdcoursing/api/openapi";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { assertNonEmptyString } from "~utils/assert";

import { type State } from "../state/state";

/** Initiate a Stripe checkout session for a room payment. */
export const onPayRoom = createAsyncThunk<
  UrlResult,
  { roomId: string; ownerId: string; amount: number },
  { state: State }
>("payments/onPayRoom", (payload, thunkAPI) => {
  const userId = thunkAPI.getState().user?.id;
  assertNonEmptyString(userId);
  return fetchPaymentGetCheckoutSession({
    body: { amount: payload.amount, recipientUserId: payload.ownerId },
    pathParams: { userId },
  });
});
